// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableWrapper__vXT6g {
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: 0px 1px 16px -1px rgba(0, 0, 0, 0.15), 1px 2px 8px -1px rgba(65, 65, 65, 0.4);
}

.hardwareTable__SZLGM {
  width: 100%;
}
.hardwareTable__SZLGM thead {
  background-color: var(--tables-title-surface);
}
.hardwareTable__SZLGM th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 15px 0;
  background-color: var(--tables-title-surface);
  border-bottom: 1px solid var(--header-stroke);
  position: sticky;
  top: 0;
}
.hardwareTable__SZLGM th:first-child {
  padding-left: 25px;
}
.hardwareTable__SZLGM th:last-child {
  padding-right: 25px;
  text-align: right;
  width: 200px;
}
@media (max-width: 1200px) {
  .hardwareTable__SZLGM th {
    padding-left: 3px;
    padding-right: 3px;
    width: 70px;
  }
  .hardwareTable__SZLGM th:first-child {
    padding-left: 15px;
  }
  .hardwareTable__SZLGM th:last-child {
    padding-right: 15px;
    width: 85px;
  }
}
.hardwareTable__SZLGM .tableSortIcon__VhQvM {
  width: 10px;
  height: 12px;
  margin-left: 3px;
  vertical-align: top;
  cursor: pointer;
}
.hardwareTable__SZLGM .tableSortIcon__VhQvM:active, .hardwareTable__SZLGM .tableSortIcon__VhQvM:focus {
  outline: none;
}
.hardwareTable__SZLGM .tableSortIcon__VhQvM path {
  fill: var(--tables-title-icon);
}
.hardwareTable__SZLGM .activeSort__JnBd6 path {
  fill: var(--tables-primary-row-icon);
}
.hardwareTable__SZLGM tr {
  cursor: pointer;
}
.hardwareTable__SZLGM tr:hover {
  background-color: var(--tables-primary-row-surface-hover);
}
.hardwareTable__SZLGM td {
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-primary-row-text-main);
  text-align: left;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.hardwareTable__SZLGM td:first-child {
  padding-left: 25px;
}
.hardwareTable__SZLGM td:last-child {
  text-align: right;
  padding-right: 25px;
}
@media (max-width: 1200px) {
  .hardwareTable__SZLGM td {
    padding-left: 3px;
    padding-right: 3px;
  }
  .hardwareTable__SZLGM td:first-child {
    padding-left: 15px;
  }
  .hardwareTable__SZLGM td:last-child {
    padding-right: 15px;
  }
}

.skeletonRow__TgwKw td {
  padding-top: 16px;
  padding-right: 25px;
  padding-bottom: 16px;
}

.skeletonText__oin6I {
  width: 100%;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/HardwareOverview/components/TableHardware/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,2DAAA;EACA,yFACE;AA1EJ;;AA8EA;EACE,WAAA;AA3EF;AA6EE;EACE,6CAAA;AA3EJ;AA8EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,6CAAA;EACA,gBAAA;EACA,MAAA;AA5EJ;AA8EI;EACE,kBAAA;AA5EN;AA+EI;EACE,mBAAA;EACA,iBAAA;EACA,YAAA;AA7EN;AAgFI;EAvBF;IAwBI,iBAAA;IACA,kBAAA;IACA,WAAA;EA7EJ;EA+EI;IACE,kBAAA;EA7EN;EAgFI;IACE,mBAAA;IACA,WAAA;EA9EN;AACF;AAkFE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAhFJ;AAkFI;EAEE,aAAA;AAjFN;AAmFI;EACE,8BAAA;AAjFN;AAsFI;EACE,oCAAA;AApFN;AAwFE;EACE,eAAA;AAtFJ;AAwFI;EACE,yDAAA;AAtFN;AA0FE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yDAAA;AAxFJ;AA0FI;EACE,kBAAA;AAxFN;AA2FI;EACE,iBAAA;EACA,mBAAA;AAzFN;AA4FI;EAnBF;IAoBI,iBAAA;IACA,kBAAA;EAzFJ;EA2FI;IACE,kBAAA;EAzFN;EA4FI;IACE,mBAAA;EA1FN;AACF;;AAgGE;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;AA7FJ;;AAiGA;EACE,WAAA;EACA,YAAA;AA9FF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tableWrapper {\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow:\n    0px 1px 16px -1px rgba(0, 0, 0, 0.15),\n    1px 2px 8px -1px rgba(65, 65, 65, 0.4);\n}\n\n.hardwareTable {\n  width: 100%;\n\n  thead {\n    background-color: var(--tables-title-surface);\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    color: var(--tables-title-text);\n    text-transform: uppercase;\n    text-align: left;\n    padding: 15px 0;\n    background-color: var(--tables-title-surface);\n    border-bottom: 1px solid var(--header-stroke);\n    position: sticky;\n    top: 0;\n\n    &:first-child {\n      padding-left: 25px;\n    }\n\n    &:last-child {\n      padding-right: 25px;\n      text-align: right;\n      width: 200px;\n    }\n\n    @media (max-width: 1200px) {\n      padding-left: 3px;\n      padding-right: 3px;\n      width: 70px;\n\n      &:first-child {\n        padding-left: 15px;\n      }\n\n      &:last-child {\n        padding-right: 15px;\n        width: 85px;\n      }\n    }\n  }\n\n  .tableSortIcon {\n    width: 10px;\n    height: 12px;\n    margin-left: 3px;\n    vertical-align: top;\n    cursor: pointer;\n\n    &:active,\n    &:focus {\n      outline: none;\n    }\n    path {\n      fill: var(--tables-title-icon);\n    }\n  }\n\n  .activeSort {\n    path {\n      fill: var(--tables-primary-row-icon);\n    }\n  }\n\n  tr {\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--tables-primary-row-surface-hover);\n    }\n  }\n\n  td {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 14px;\n    color: var(--tables-primary-row-text-main);\n    text-align: left;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n    &:first-child {\n      padding-left: 25px;\n    }\n\n    &:last-child {\n      text-align: right;\n      padding-right: 25px;\n    }\n\n    @media (max-width: 1200px) {\n      padding-left: 3px;\n      padding-right: 3px;\n\n      &:first-child {\n        padding-left: 15px;\n      }\n\n      &:last-child {\n        padding-right: 15px;\n      }\n    }\n  }\n}\n\n.skeletonRow {\n  td {\n    padding-top: 16px;\n    padding-right: 25px;\n    padding-bottom: 16px;\n  }\n}\n\n.skeletonText {\n  width: 100%;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `tableWrapper__vXT6g`,
	"hardwareTable": `hardwareTable__SZLGM`,
	"tableSortIcon": `tableSortIcon__VhQvM`,
	"activeSort": `activeSort__JnBd6`,
	"skeletonRow": `skeletonRow__TgwKw`,
	"skeletonText": `skeletonText__oin6I`
};
module.exports = ___CSS_LOADER_EXPORT___;
